import { secondsToMinutes } from '../utils';

let timer;

export const startIdleTimer = (timeout, idleAction) => {
  timer = setTimeout(idleAction, timeout);
  console.log(`Idle Timer (${timer}): Started for ${secondsToMinutes(timeout / 1000)} minute(s).`); // eslint-disable-line no-console
};

export const stopIdleTimer = () => {
  clearTimeout(timer);
  console.log(`Idle Timer (${timer}): Stopped.`); // eslint-disable-line no-console
};
